import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import RichText from '../../../../../utils/RichText';
import CustomInputCheckbox from '../../../../../utils/redux-forms-custom-fields/CustomInputCheckbox';

const EmailSettings = ({
  questForm,
  emailFailureSentDate,
  emailReminderSentDate,
  questMeetsReminderMin,
  onRichTextUpdate
}) => {
  return (
    <div>
      <section className="WhiteListWrapper__header">
        <h3 className="WhiteListWrapper__header--title">
          Approval Email
        </h3>
      </section>
      <div className="input-container main_desc">
        <label>
          Reminders & Other Info
          <span className="tooltip">
            <i className="tooltip-icon fa fa-info-circle" />
            <div className="tooltip-content">
              This will appear in the automated quest approval email (alongside existing date, payment, and requirement info). If left blank, default text will be used.
            </div>
          </span>
        </label>
        {questForm.values && (
          <RichText
            callback={content => onRichTextUpdate(content, 'emailAdditionalInfo')}
            initialValue={questForm.values.emailAdditionalInfo}
          />
        )}
      </div>

      <section className="WhiteListWrapper__header">
        <h3 className="WhiteListWrapper__header--title">
          Failure Email
        </h3>
      </section>
      <div className="input-container main_desc">
        <label>
          Send Failure Email
          <span className="tooltip">
            <i className="tooltip-icon fa fa-info-circle" />
            <div className="tooltip-content">
              If checked, all users in this quest who are missing requirements or stream time will be sent a quest failure email 24 hours after the quest ends.
            </div>
          </span>
        </label>
        {emailFailureSentDate ? (
          <span style={{ fontStyle: 'italic' }}> 
            Automated failure emails were sent on {emailFailureSentDate} 
          </span>
        ) : (
          <Field
            name="emailFailure.shouldSend"
            id="emailFailure.shouldSend"
            type="checkbox"
            placeholder="Select Value"
            component={CustomInputCheckbox}
          />
        )}
      </div>

      <div className="input-container main_desc">
        <label>
          Send Reminder Email
          <span className="tooltip">
            <i className="tooltip-icon fa fa-info-circle" />
            <div className="tooltip-content">
              If checked, all users in this quest who are missing requirements or stream time will be sent a quest reminder email 48 hours before the quest ends.
            </div>
          </span>
        </label>
        {emailReminderSentDate ? (
          <span style={{ fontStyle: 'italic' }}>
            Automated reminder emails were sent on {emailReminderSentDate}
          </span>
        ) : !questMeetsReminderMin ? (
          <span style={{ fontStyle: 'italic' }}>
            Reminder emails do not send for quests with a duration of less than 48 hours.
          </span>
        ) : (
          <Field
            name="emailReminder.shouldSend"
            id="emailReminder.shouldSend"
            type="checkbox"
            placeholder="Select Value"
            component={CustomInputCheckbox}
          />
        )}
      </div>
    </div>
  );
};

EmailSettings.propTypes = {
  questForm: PropTypes.shape({
    values: PropTypes.shape({
      emailAdditionalInfo: PropTypes.string
    })
  }).isRequired,
  emailFailureSentDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]).isRequired,
  emailReminderSentDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]).isRequired,
  questMeetsReminderMin: PropTypes.bool.isRequired,
  onRichTextUpdate: PropTypes.func.isRequired
};

export default EmailSettings;